import {Component, EventEmitter, Input, OnDestroy, OnInit, Output,} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {take} from 'rxjs/operators';
import {UserModel} from 'src/app/models/User';
import {AuthService} from 'src/app/services/auth.service';
import {ViewportService} from 'src/app/services/viewport.service';
import {IntercomService} from 'src/app/services/intercom.service';
import {Router} from '@angular/router';
import {MixpanelService} from '../../../services/mixpanel.service';

@Component({
    selector: 'delete-modal',
    templateUrl: './delete-modal.component.html',
    styleUrl: './delete-modal.component.css',
})
export class DeleteModalComponent implements OnInit, OnDestroy {
    @Input() visible = false;
    @Output() onClose = new EventEmitter<void>();

    user: UserModel;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public viewport: ViewportService,
        private auth: AuthService,
        public intercom: IntercomService,
        private router: Router,
        private mixpanel: MixpanelService
    ) {}

    ngOnInit() {
        this.auth.user$
        .pipe(
            take(1),
        )
        .subscribe((u) => {
            this.user = u;
            this.mixpanel.identify(u.id.toString())
            this.mixpanel.track('Delete modal opened')
        });
    }
    ngOnDestroy(): void {}

    hide() {
        this.onClose.emit();
    }

    close() {
        this.mixpanel.track('Delete modal closed')
        this.ref.close();
    }

    clickDowngrade() {
        this.mixpanel.track('Downgrade plan button clicked')

        const target = this.user.isPaid
          ? '/upgrade/planoptions'
          : this.user.upgradeLink || '/upgrade/upgradeoptions';

        this.router.navigate([target], {
            queryParams: {
                upgrade_source: 'dashboard_account_settings_downgrade',
                upgrade_campaign: '1_14_day_trial',
                upgrade_cohort: '2026'
            }
        });
        this.close();
      }

    clickContactSupport() {
        this.mixpanel.track('Contact Support button clicked')
        this.intercom.openMessenger();
        this.close()
    }
}
